import { useEffect, useState } from "react";
import {
  Typography,
  makeStyles,
  CircularProgress,
  Button
} from "@material-ui/core";
import { Steps, useAppState } from "../../state";

const useStyles = makeStyles(theme => ({
  customerBgContainer: {
    margin: "0 auto 1em",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundSize: "contain",
    width: "300px",
    height: "20vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down("sm")]: {
      backgroundPosition: "top",
      backgroundSize: "cover",
      width: "100%"
    }
  }
}));

export default function FindItemView() {
  const {
    clientID,
    locationID,
    setCurrentStep,
    findQuery,
    coverURL,
    aisleId,
    setAisleId
  } = useAppState();
  const [aiResult, setAiresult] = useState("");
  const [loading, setLoading] = useState(false);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [departmentsLoaded, setDepartmentsLoaded] = useState(false); // State to track if departments are loaded
  const classes = useStyles();
  const goClientHome = () => setCurrentStep(Steps.landingAccountPage);

  let hostServerURL = window.location.hostname;
  hostServerURL === "localhost"
    ? (hostServerURL = "http://localhost:8081")
    : (hostServerURL = "https://" + window.location.hostname);
  const departmentsListURL = `${hostServerURL}/departments?clientId=${encodeURIComponent(
    clientID
  )}&locationId=${encodeURIComponent(locationID)}`;
  const findDepartmentUrl = `${hostServerURL}/find-department`;
  let clientNaicsCode = "";

  useEffect(() => {
    const getDepartments = async () => {
      setLoading(true);

      try {
        const response = await fetch(departmentsListURL, { method: "GET" });
        if (response.ok) {
          let clientDepartmentsData = await response.json();

          if ((await clientDepartmentsData.data.length) <= 0) {
            console.log("No departments found for this client");
            const departmentsListURL = `${hostServerURL}/departments?clientId=9999&locationId=9999`;
            const response = await fetch(departmentsListURL, { method: "GET" });
            if (response.ok) {
              clientDepartmentsData = await response.json();
            } else {
              throw new Error("Request failed");
            }
          }
          const clientDepartmentsNames = clientDepartmentsData.data.map(
            (item: { dptName: any }) => item.dptName
          );
          setDepartmentsData(clientDepartmentsData.data);
          setDepartmentsList(clientDepartmentsNames);
          setDepartmentsLoaded(true);
        } else {
          throw new Error("Request failed");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getDepartments();
  }, [clientID, locationID, departmentsListURL]);

  useEffect(() => {
    if (!departmentsLoaded) {
      return;
    }

    const searchGPT = async () => {
      setLoading(true);
      try {
        const response = await fetch(findDepartmentUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            findQuery,
            departmentsList,
            clientNaicsCode
          })
        });

        if (response.ok) {
          const data = await response.json();
          const aiChoosenDepartment = data.department;
          console.log("ChatGPT Response:", aiChoosenDepartment);
          setAiresult(aiChoosenDepartment);

          departmentsData.forEach(department => {
            const departmentName = department["dptName"] || "";
            const aisleNumber = department["aisleId"] || "";
            //if (aiChoosenDepartment.trim().toLowerCase() === departmentName.trim().toLowerCase()) {
            if (aiChoosenDepartment === departmentName) {
              setAisleId(aisleNumber);
            }
          });
        } else {
          throw new Error("Request failed");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    searchGPT();
  }, [
    findQuery,
    departmentsList,
    departmentsLoaded,
    departmentsData,
    findDepartmentUrl,
    setAisleId
  ]);

  return (
    <div className="centrado">
      <div
        className={classes.customerBgContainer}
        style={{ backgroundImage: `url(${coverURL})` }}
      ></div>
      <br />
      <Typography variant="subtitle1">
        You will find <b>{findQuery}</b> in
      </Typography>
      <br />
      {loading && <CircularProgress />}
      <Typography align="center" variant="h5">
        {aiResult}
      </Typography>
      <br />
      {!loading && aisleId && (
        <Typography variant="h6">Aisle {aisleId}</Typography>
      )}
      <br />
      <Button
        onClick={goClientHome}
        color="primary"
        variant="contained"
        disabled={loading}
      >
        {loading ? "Loading..." : "New Help Request"}
      </Button>
    </div>
  );
}
